import { SVGProps } from 'react'

export const VideoScreenShotIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.55127" width="64" height="64" rx="32" fill="#00A4FF" />
    <path
      d="M26.1631 29.9474C26.1631 29.7254 26.1631 29.6144 26.1723 29.5209C26.2617 28.6192 26.975 27.9059 27.8767 27.8166C27.9702 27.8073 28.0872 27.8073 28.3211 27.8073C28.4113 27.8073 28.4564 27.8073 28.4946 27.805C28.9834 27.7754 29.4113 27.4669 29.5939 27.0127C29.6082 26.9771 29.6216 26.937 29.6483 26.8568C29.6751 26.7766 29.6884 26.7365 29.7027 26.7009C29.8854 26.2466 30.3133 25.9382 30.802 25.9086C30.8403 25.9062 30.8826 25.9062 30.9671 25.9062H34.0327C34.1172 25.9062 34.1595 25.9062 34.1978 25.9086C34.6865 25.9382 35.1145 26.2466 35.2971 26.7009C35.3114 26.7365 35.3247 26.7766 35.3515 26.8568C35.3782 26.937 35.3916 26.9771 35.4059 27.0127C35.5885 27.4669 36.0165 27.7754 36.5052 27.805C36.5434 27.8073 36.5885 27.8073 36.6787 27.8073C36.9126 27.8073 37.0296 27.8073 37.1231 27.8166C38.0248 27.9059 38.7381 28.6192 38.8275 29.5209C38.8367 29.6144 38.8367 29.7254 38.8367 29.9474V34.9045C38.8367 35.9692 38.8367 36.5016 38.6295 36.9082C38.4473 37.2659 38.1564 37.5568 37.7987 37.739C37.3921 37.9462 36.8597 37.9462 35.7951 37.9462H29.2048C28.1401 37.9462 27.6077 37.9462 27.2011 37.739C26.8434 37.5568 26.5525 37.2659 26.3703 36.9082C26.1631 36.5016 26.1631 35.9692 26.1631 34.9045V29.9474Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M32.4999 35.0946C33.8998 35.0946 35.0346 33.9598 35.0346 32.5599C35.0346 31.16 33.8998 30.0252 32.4999 30.0252C31.1 30.0252 29.9652 31.16 29.9652 32.5599C29.9652 33.9598 31.1 35.0946 32.4999 35.0946Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.5 21.3013H27.25C25.1498 21.3013 24.0997 21.3013 23.2975 21.71C22.5919 22.0695 22.0183 22.6432 21.6587 23.3488C21.25 24.151 21.25 25.2011 21.25 27.3013V27.5513M27.5 43.8013H27.25C25.1498 43.8013 24.0997 43.8013 23.2975 43.3925C22.5919 43.033 22.0183 42.4593 21.6587 41.7537C21.25 40.9516 21.25 39.9015 21.25 37.8013V37.5513M43.75 27.5513V27.3013C43.75 25.2011 43.75 24.151 43.3413 23.3488C42.9817 22.6432 42.4081 22.0695 41.7025 21.71C40.9003 21.3013 39.8502 21.3013 37.75 21.3013H37.5M43.75 37.5513V37.8013C43.75 39.9015 43.75 40.9516 43.3413 41.7537C42.9817 42.4593 42.4081 43.033 41.7025 43.3925C40.9003 43.8013 39.8502 43.8013 37.75 43.8013H37.5"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
